import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  effect,
  input,
  signal,
} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { firstValueFrom } from 'rxjs';

import { SvgService } from './svg.service';

@Component({
  selector: 'ui-inline-svg',
  imports: [ CommonModule ],
  template: '<div class="wrapper" [innerHTML]="svgIcon()"></div>',
  styleUrl: './inline-svg.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InlineSvgComponent {

  /** The name of the SVG icon to be loaded. */
  name = input<string>('');

  /** The sanitized HTML content of the loaded SVG icon. */
  svgIcon = signal<SafeHtml | null>(null);

  /** Creates an instance of `SvgIconComponent`. */
  constructor(private sanitizer: DomSanitizer, private svgService: SvgService) {
    effect(() => this.loadSvg(this.name()));
  }

  /** Asynchronously loads an SVG icon by its name. */
  async loadSvg(name: string): Promise<void> {
    const svg$ = this.svgService.getSvg(name);

    if (!svg$) {
      return;
    }

    const svg = await firstValueFrom(svg$);

    this.svgIcon.set(this.sanitizer.bypassSecurityTrustHtml(svg));
  }
}
